export default __webpack_public_path__ + "static/media/05_grandfather.5eff7f8f.png";